import PropTypes from 'prop-types';
import { LogOut, Settings } from 'lucide-react';
import SidebarContainer from './SidebarContainer';
import SidebarHeader from './SidebarHeader';
import SidebarLogo from './SidebarLogo';
import SidebarMenuLabel from './SidebarMenuLabel';
import SidebarNav from './SidebarNav';
import SidebarFooter from './SidebarFooter';
import { useSidebarLogic } from './hooks';
import { useSidebarContext } from './SidebarContext';
import logo from '../../assets/LOGO (2).png';

export default function Sidebar({ isOpen = false, onClose }) {
  const { links, pathname, handleLinkClick, handleLogout, handleSettings, shouldShowSidebar } =
    useSidebarLogic(onClose);
  const { isCompact } = useSidebarContext();

  if (!shouldShowSidebar) {
    return null;
  }

  return (
    <SidebarContainer isOpen={isOpen} onClose={onClose} isCompact={isCompact}>
      {isCompact ? (
        <SidebarLogo isCompact={true} />
      ) : (
        <SidebarHeader logo={logo} title="Easy Survey" subtitle="Gestion de sondages" />
      )}
      {!isCompact && <SidebarMenuLabel />}
      <SidebarNav links={links} activeLink={pathname} onLinkClick={handleLinkClick} isCompact={isCompact} />
      <SidebarFooter
        onSettings={{
          icon: Settings,
          label: 'Paramètres',
          onClick: handleSettings,
        }}
        onLogout={{
          icon: LogOut,
          label: 'Déconnexion',
          onClick: handleLogout,
        }}
        isCompact={isCompact}
      />
    </SidebarContainer>
  );
}

Sidebar.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

Sidebar.defaultProps = {
  isOpen: false,
};
